import { useState, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';

import * as REST from '~services/rest';
import { loadStripe } from '@stripe/stripe-js/pure';
import { UserContext } from '~contexts/user';

const useStripe = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { stripeApiKey, translations } = useSelector((state) => state.domainConfig);
  const { user } = useContext(UserContext);
  const [clientSecret, setClientSecret] = useState('');
  const [checkoutSessionUrl, setCheckoutSessionUrl] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  const appearance = {
    theme: 'stripe',
  };

  const initialize = async () => {
    await setStripePromise(loadStripe(stripeApiKey, { locale: translations.substr(0, translations.indexOf('_')) }));
  }; 

  // stripe one time payment
  const fetchIntent = async (personId, currency, amount, locationId, returnUrl) => {
    try {
      setIsLoading(true);
      if (!clientSecret) {
        await initialize();
      }

      const token = await getAccessTokenSilently();
      const result = await REST.post({
        name: `payments`,
        requiresAuthentication: true,
        mockFileName: 'payments/post-prepare-payment',
        params: {
          person_id: personId,
          place_id: locationId,
          currency,
          value: parseInt(amount, 10),
          return_url: returnUrl,
          is_subscription:"no"
        },
        token,
      });

      const cSecret = result?.data[0]?.client_secret;

      if (!cSecret) {
        setError(true);
        setClientSecret('');
        setIsLoading(false);
        return;
      }

      setClientSecret(cSecret);
      setError(null);
      setIsLoading(false);
    } catch (err) {
      console.log('Error when fetching payment secret', err);
      setError(true);
      setClientSecret('');
      setIsLoading(false);
    }
  };

  // stripe subscripetion payment
  const fetchCheckoutSessionUrl = async (personId, currency, amount, locationId, returnUrl) => {
    try {
      setIsLoading(true);
      if (!clientSecret) {
        await initialize();
      }

      const intakeLocationId = user?.wish?.address?.place_id || locationId;

      const token = await getAccessTokenSilently();
      const result = await REST.post({
        name: `payments`,
        requiresAuthentication: true,
        mockFileName: 'payments/post-prepare-payment',
        params: {
          person_id: personId,
          place_id: intakeLocationId,
          currency,
          value: parseInt(amount, 10),
          return_url: returnUrl,
          is_subscription:"yes",
        },
        token,
      });

      const cSecret = result?.data[0]?.client_secret;
      const cSUrl = result?.data[0]?.checkout_session_url;

      if (!cSUrl) {
        setError(true);
        setCheckoutSessionUrl('');
        setIsLoading(false);
        return;
      }

      setCheckoutSessionUrl(cSUrl);
      setError(null);
      setIsLoading(false);
    } catch (err) {
      console.log('Error when fetching checkout session url', err);
      setError(true);
      setCheckoutSessionUrl('');
      setIsLoading(false);
    }
  };

  // stripe subscripetion payment
  const retriveCheckoutSession = async (session_id) => {
    try {
      // setIsLoading(true);
      // if (!clientSecret) {
      //   await initialize();
      // }

      const token = await getAccessTokenSilently();
      const result = await REST.get({
        name: `payments`,
        requiresAuthentication: true,
        mockFileName: 'payments/retrive-stripe-session',
        params: {
          "stripe-session-id": session_id,
        },
        token,
      });

      return result;

      // console.log(result)

      // const cSecret = result?.data[0]?.client_secret;
      // const cSUrl = result?.data[0]?.checkout_session_url;

      // if (!cSUrl) {
      //   setError(true);
      //   setCheckoutSessionUrl('');
      //   setIsLoading(false);
      //   return;
      // }

      // setCheckoutSessionUrl(cSUrl);
      // setError(null);
      // setIsLoading(false);
    } catch (err) {
      console.log('Error when fetching checkout session url', err);
      // setError(true);
      // setCheckoutSessionUrl('');
      // setIsLoading(false);
    }
  };

  return { stripePromise, clientSecret, checkoutSessionUrl, isLoading, error, appearance, fetchIntent, initialize, fetchCheckoutSessionUrl, retriveCheckoutSession };
};

export default useStripe;
